import Vue from 'vue';
import api from '../../utils/api';
import utilities from '../../utils/utilities';
import constants from '../constants';
import router from '../../router';

// initial state
const state = {
    email: 'john@example.com',
    password: 'password',
    errors: {}
};

// mutations
const mutations = {
    email(state, email) {
        state.email = email;
    },
    password(state, password) {
        state.password = password;
    },
    errors(state, errors) {
        state.errors = errors;
    }
};

// getters
const getters = {
};

// actions
const actions = {
    setEmail(store, payload) {
        store.commit('email', payload);
    },
    setPassword(store, payload) {
        store.commit('password', payload);
    },
    signin(store, btn) {
        utilities.disableButton(btn);
        api.post(
            '/api/account/signin',
            {
                email: store.state.email,
                password: store.state.password
            },
            'signin/errors').then(
            response => {
                const authorizationData = response.body;

                try {
                    localStorage.setItem(constants.tokenKey, JSON.stringify(authorizationData));
                } catch (e) {
                    //localstorage is not supported (it could be if external cookies are turned off and you are running app in iframe)
                }
                Vue.http.headers.common['Authorization'] = 'Bearer ' + authorizationData.token;
                router.push({
                    name: 'dashboard'
                });
                store.dispatch('settings/initAccount',
                    authorizationData,
                    { root: true });
                utilities.enableButton(btn);
            },
            function() {
                utilities.enableButton(btn);
            });
    },
    openSignUp() {
        router.push({
            name: 'signup'
        });
    },
    openForgotPassword() {
        router.push({
            name: 'forgot-password'
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/signin.js